package fr.frux.shared.presentation

/**
 * Seul endroit qui décide des mots du passage humain (ADR 0025, #427) : la fiche arbre et la
 * vignette de liste affichent toutes les deux cette phrase, sans en réécrire une seconde. Les mots
 * vivent ici, en dur et à côté de [relativeAgeLabel], parce que la phrase est assemblée à partir
 * des deux et qu'un seul mécanisme de texte doit la porter (une moitié en ressource compose et
 * l'autre en Kotlin dérivaient sans que rien ne le voie). Même parti que les libellés de saison
 * de `core-designsystem`.
 *
 * [lastObservedAtMillis] est `null` quand le niveau `SEEN_LONG_AGO` vient de la seule photo
 * (aucune observation datée, cf. [treeSighting]) : une photo atteste d'un passage, mais rien ne le
 * date, y compris quand elle vient d'être prise. Rendre "il y a un moment" serait faux dans ce cas
 * fréquent ; une phrase dédiée sans date le dit sans mentir.
 *
 * [nowMillis] doit être l'horloge qui a servi à dériver [sighting], jamais une seconde lecture de
 * l'heure : le niveau affiché et la date qu'il porte viennent de la même horloge (#420).
 */
fun treeSightingLabel(
    sighting: TreeSighting,
    lastObservedAtMillis: Long?,
    nowMillis: Long,
): String =
    when (sighting) {
        TreeSighting.NEVER_SEEN -> {
            "Personne n'est encore passé devant cet arbre"
        }

        TreeSighting.SEEN_LONG_AGO -> {
            lastObservedAtMillis?.let { "Vu pour la dernière fois ${relativeAgeLabel(it, nowMillis)}" }
                ?: "Une photo atteste d'un passage, sans date"
        }

        TreeSighting.SEEN_RECENTLY -> {
            "Vu récemment, ${relativeAgeLabel(requireNotNull(lastObservedAtMillis), nowMillis)}"
        }
    }
